export default "__VITE_PUBLIC_ASSET__46fe225d__"